import { ProjectState, ProjektstadiumType } from '@models/project';

export interface UserSettings {
  benutzerId?: string;
  aktuelleOrganisation?: { organisationId?: string; bezeichnung?: string };
  einstellungen?: UserSettingsSettings;
}

export interface UserSettingsSettings {
  aktuellesProjektstadium?: ProjectState;
  organisationId?: string;
  benutzerId?: string;
}

export interface UserSettingsProjectState {
  projektstadiumId?: string;
  projektId?: string;
  nummer?: string;
  kurzname?: string;
  projektstadiumTypId?: string;
  stadiumname?: string;
}

export function convertUserSettingsProjectStateToProjectState(
  userSettingsProjectState: UserSettingsProjectState,
): Partial<ProjectState> {
  const stadiumTypMap: Record<string, ProjektstadiumType> = {
    Angebot: ProjektstadiumType.Angebot,
    Auftrag: ProjektstadiumType.Auftrag,
    Arbeit: ProjektstadiumType.Arbeit,
  };

  const stadiumTyp = stadiumTypMap[userSettingsProjectState.stadiumname || ''];
  return {
    projektstadiumId: userSettingsProjectState.projektstadiumId,
    projektId: userSettingsProjectState.projektId,
    projektstadiumnummer: userSettingsProjectState.nummer,
    kurzname: userSettingsProjectState.kurzname,
    stadiumTyp,
    projektstadiumTypId: userSettingsProjectState.projektstadiumTypId,
  };
}
